import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './page/home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { MissionAndVisionComponent } from './page/mission-and-vision/mission-and-vision.component';

// Admin Login and Out
import { LoginComponent } from './page/admin/login/login.component';
import { CreateAccountComponent } from './page/admin/create-account/create-account.component';
import { CreatePasswordComponent } from './page/admin/create-password/create-password.component';
import { ForgotPasswordComponent } from './page/admin/forgot-password/forgot-password.component';

// Adovacy Dropdown Menu
import { CHCCPolicyPerspectiveComponent } from './page/chccpolicy-perspective/chccpolicy-perspective.component';
import { BillPositionsComponent } from './page/bill-positions/bill-positions.component';
import { CHCCPacComponent } from './page/chccpac/chccpac.component';
import { PolicyCoalitionComponent } from './page/policy-coalition/policy-coalition.component';
import { PolicyEngagementAndResourcesComponent } from './page/policy-engagement-and-resources/policy-engagement-and-resources.component';

// Business Dropdown Menu
import { SupplierDiversityComponent } from './page/supplier-diversity/supplier-diversity.component';

// Events Dropdown Menu
import { CaliforniaBusinessPolicySummitComponent } from './page/california-business-policy-summit/california-business-policy-summit.component';
import { LegislativeAndEconomicOutlookComponent } from './page/legislative-and-economic-outlook/legislative-and-economic-outlook.component';
import { AnnualConventionComponent } from './page/annual-convention/annual-convention.component';

// Membership Dropdown Menu
import { ChamberMembersComponent } from './page/chamber-members/chamber-members.component';
import { CorporateMembershipComponent } from './page/corporate-membership/corporate-membership.component';
import { CorporatePartnershipProgramComponent } from './page/corporate-partnership-program/corporate-partnership-program.component';

// Media Dropdown Menu
import { NewsAndCurrentAffairComponent } from './page/news-and-current-affair/news-and-current-affair.component';

// About Dropdown Menu
import { AboutCHCCComponent } from './page/about-chcc/about-chcc.component';
import { BoardOfDirectorsComponent } from './page/board-of-directors/board-of-directors.component';
import { StaffComponent } from './page/staff/staff.component';
import { CHCCFoundationComponent } from './page/chccfoundation/chccfoundation.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { FinancialComponent } from './page/financial/financial.component';

// Generic Component will house all other pages
import { GenericComponent } from './page/generic/generic.component';
import { ResetPasswordComponent } from './page/admin/reset-password/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'login/create-account',
        component: CreateAccountComponent,
      },
      {
        path: 'create-password/:id',
        component: CreatePasswordComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'mission-and-vision',
        component: GenericComponent,
      },
      // Adovacy Dropdown Menu
      {
        path: 'policy-perspective',
        component: GenericComponent,
      },
      {
        path: 'bill-positions',
        component: BillPositionsComponent,
      },
      {
        path: 'policy-engagement-resources',
        component: GenericComponent,
      },
      {
        path: 'policy-coalition',
        component: GenericComponent,
      },
      {
        path: 'chcc-pac',
        component: GenericComponent,
      },
      // Business Resources Dropdown Menu
      {
        path: 'supplier-diversity-procurement',
        component: GenericComponent,
      },
      // Events Dropdown Menu
      {
        path: 'annual-convention',
        component: GenericComponent,
      },
      {
        path: 'ca-business-policy-summit',
        component: GenericComponent,
      },
      {
        path: 'legislative-economic-outlook',
        component: GenericComponent,
      },
      // Membership  Dropdown Menu
      {
        path: 'chamber-members',
        component: GenericComponent,
      },
      {
        path: 'corporate-membership',
        component: CorporateMembershipComponent,
      },
      {
        path: 'corporate-partnership-program',
        component: GenericComponent,
      },
      // About Dropdown Menu
      {
        path: 'about',
        component: GenericComponent,
      },
      {
        path: 'chcc-foundation',
        component: GenericComponent,
      },
      {
        path: 'board-of-directors',
        component: GenericComponent,
      },
      {
        path: 'financial',
        component: FinancialComponent,
      },
      {
        path: 'staff',
        component: GenericComponent,
      },
      {
        path: 'contact',
        component: GenericComponent,
      },
      {
        path: "testing",
        component: GenericComponent
      },
      {
        path: "reset-password/:id",
        component: ResetPasswordComponent
      },
      {
        path: "page/:route",
        component: GenericComponent
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
